// Dati di Customers V2: clienti, progetti e contratti collegati, creazione, modifica ed eliminazione.
import { API_ENDPOINTS } from '../config/api.config';

async function request(url, options) {
  const res = await fetch(url, options);
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  if (!res.ok) throw new Error(body?.error || body?.message || `Request failed (${res.status})`);
  return body || {};
}

const jsonOptions = (method, payload) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload),
});

/**
 * Clienti con i progetti e i contratti di tutti i clienti (per conteggi e dettaglio).
 * contracts è null se l'elenco dei contratti non è disponibile: la pagina funziona comunque.
 */
export async function fetchCustomersBundle() {
  const [c, p, ct] = await Promise.all([
    request(API_ENDPOINTS.CUSTOMERS),
    request(API_ENDPOINTS.PROJECTS),
    request(API_ENDPOINTS.CONTRACTS).catch(() => null),
  ]);
  return { customers: c.customers || [], projects: p.projects || [], contracts: ct ? ct.contracts || [] : null };
}

export const createCustomer = (payload) => request(API_ENDPOINTS.CUSTOMERS, jsonOptions('POST', payload));
export const updateCustomer = (id, payload) => request(`${API_ENDPOINTS.CUSTOMERS}?id=${id}`, jsonOptions('PUT', payload));
export const deleteCustomer = (id) => request(`${API_ENDPOINTS.CUSTOMERS}?id=${id}`, { method: 'DELETE' });

/** Errori del form cliente: nome obbligatorio e non già usato da un altro cliente. */
export function validateCustomerForm(form, customers, editingId) {
  const e = {};
  const name = form.name.trim();
  if (!name) e.name = 'Required';
  else if (customers.some((c) => String(c.name || '').trim().toLowerCase() === name.toLowerCase() && String(c.id) !== String(editingId))) {
    e.name = 'Another customer already has this name';
  }
  return e;
}
